var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "c-screen-indicator",
        staticStyle: { "margin-right": "150px" },
        on: { click: _vm.openModal }
      },
      [_vm._v("\n    Bekijk online spelers\n  ")]
    ),
    _vm._v(" "),
    _c("div", { ref: "main" }, [
      _c(
        "div",
        {
          ref: "content",
          staticClass: "modal-content",
          class: { hidden: !_vm.show }
        },
        [
          _c("div", { staticClass: "modal__header" }, [
            _c("h1", [_vm._v(_vm._s(_vm.onlineCount) + " spelers online")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.className))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__content" }, [
            _c("table", { staticClass: "contenttable" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.teams, function(team) {
                  return _c("TeamOverviewTeam", {
                    key: team.uuid,
                    attrs: {
                      team: team,
                      "online-students": _vm.onlineStudents
                    },
                    on: { electLeader: _vm.electLeader }
                  })
                }),
                1
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Planeetnaam")]),
        _vm._v(" "),
        _c("th", [_vm._v("Teamleider")]),
        _vm._v(" "),
        _c("th", [_vm._v("Aantal spelers")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }